import { Component } from '@angular/core';
import { ProjectsHeroComponent } from "./components/projects-hero/projects-hero.component";
import { ProjectsGridComponent } from "./components/projects-grid/projects-grid.component";
import { ProjectsCtaComponent } from "./components/projects-cta/projects-cta.component";

@Component({
  selector: 'app-projects',
  imports: [ProjectsHeroComponent, ProjectsGridComponent, ProjectsCtaComponent],
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.css',
})
export class ProjectsComponent {

}
